'use client';

import { type ReactNode, useState } from 'react';
import * as PopoverComponent from '@radix-ui/react-popover';
import { Text } from '../Text';

export type TooltipProps = {
	className?: string;
	trigger: ReactNode;
	text: string;
};

export function Tooltip(props: TooltipProps) {
	const [open, setOpen] = useState(false);

	function handleOpen() {
		setOpen(true);
	}

	function handleClose() {
		setOpen(false);
	}

	return (
		<div className={props.className} data-component='Tooltip'>
			<PopoverComponent.Root open={open}>
				<PopoverComponent.Trigger asChild onClick={() => setOpen(!open)} onMouseEnter={handleOpen} onMouseLeave={handleClose}>
					{props.trigger}
				</PopoverComponent.Trigger>
				<PopoverComponent.Portal>
					<PopoverComponent.Content
						className={`outline-hidden!`}
						side='top'
						sideOffset={5}
						onMouseEnter={handleOpen}
						onMouseLeave={handleClose}
					>
						<Text
							as='div'
							className={'bg-background-white-glass rounded-md py-1 px-2 border border-border-white backdrop-blur-2xl'}
							styleType='body-xs'
						>
							{props.text}
						</Text>
					</PopoverComponent.Content>
				</PopoverComponent.Portal>
			</PopoverComponent.Root>
		</div>
	);
}
